import { AxiosInstance } from 'axios';
import { SITE_URL } from './service';
import { addFormValues } from './utils';
import { type Crop } from 'react-image-crop';

export const baseEndpoint = 'image';

export class ImageApi {
  constructor(private api: AxiosInstance) {}

  async downloadUserCropImages(formValues: UserCropDownloadFormValues): Promise<Blob> {
    const formData = new FormData();

    addFormValues({ ...formValues }, formData);

    const response = await this.api.post('/admin/user-crops/download', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });

    return response.data;
  }

  async uploadBackgroundThemePreset(formValues: BackgroundThemePresetFormValues): Promise<void> {
    const formData = new FormData();

    addFormValues({ ...formValues }, formData);

    await this.api.post('/admin/background-theme/preset', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async uploadBackgroundThemeSquare(formValues: BackgroundThemeSquareFormValues): Promise<void> {
    const formData = new FormData();

    addFormValues({ ...formValues }, formData);

    await this.api.post('/admin/background-theme/square', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async scrapeIcon(url: string): Promise<string | null> {
    const response = await this.api.post<{ iconId: string | null }>('/icon', { url });
    return response.data.iconId;
  }

  getIconSrc(iconId: string): string {
    return `${SITE_URL}/image/icon/${iconId}`;
  }

  getPlaceholderSrc(size: string, ratio: string): string {
    return `${SITE_URL}/image/placeholder?size=${size}&ratio=${ratio}`;
  }
}

type UserCropDownloadFormValues = {
  file: File;
  squareCrop: Crop;
  rectangleCrop?: Crop;
};

type BackgroundThemePresetFormValues = {
  file: File;
  themeId: string;
  subThemeId?: string;
};

type BackgroundThemeSquareFormValues = {
  file: File;
  squareCrop: Crop;
  themeId: string;
  subThemeId?: string;
};
